import { humanize } from '../utils/string';

const FormErrors = ({ errors }) => {
  const hasErrors = errors && Object.keys(errors).length > 0;

  if (!hasErrors) {
    return null;
  }

  const renderErrors = (errors) => {
    if (typeof errors === 'object' && !Array.isArray(errors)) {
      return Object.keys(errors).map((key, index) => {
        return (
          <li className='text-sm' key={index}>
            {humanize(key)} {errors[key]}
          </li>
        );
      });
    } else if (Array.isArray(errors)) {
      return errors.map((error, index) => (
        <li className='text-sm' key={index}>
          {error}
        </li>
      ));
    } else {
      return <li className='text-sm'>{errors}</li>;
    }
  };

  return (
    <div className={`${hasErrors ? 'bg-rose-100 p-4 rounded-md my-2 text-center' : 'hidden'}`}>
      <ul className='list-inside text-rose-500'>{renderErrors(errors)}</ul>
    </div>
  );
};

export default FormErrors;
